module.exports = __webpack_public_path__ + "img/ben_hill_stadium.96f80f60.jpg";